export default "__VITE_ASSET__jV_RuEK$__"